import { createSlice } from "@reduxjs/toolkit";

export const stateSlice = createSlice({
    name: 'states',
    initialState: {
        value: []
    },
    reducers: {
        add: (state, action) => {
            state.value.push( action.payload );
        },
        addMany: (state, action) => {
            state.value = [ ...state.value, ...action.payload ];
        },
        setStates: (state, action) => {
            state.value = action.payload;
        }
    }
});

export const { add, addMany,setStates } = stateSlice.actions;

export default stateSlice.reducer;
